$ = jQuery.noConflict();

$(() => {

	$('#edit-gerar-boletos').on('click', function(){
		var el = $(this);
		if($('#edit-boleto-parcelas').val()){
			setTimeout(function(){
				el.attr('disabled','disabled');
				el.addClass('btn-disabled');
			}, 100);
		}
	});

});